import { type InputRule } from "prosemirror-inputrules";
import { type MarkType } from "prosemirror-model";

import { wrappingMarkRule } from "./wrappingMarkRule";

export const inlineCodeRule = (markType: MarkType): InputRule => {
	return wrappingMarkRule(/`([^`]+)`/, markType, {});
};
